import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_d2bb196e from 'nuxt_plugin_plugin_d2bb196e' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_axios_8f4ea892 from 'nuxt_plugin_axios_8f4ea892' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_elementui_69306e1c from 'nuxt_plugin_elementui_69306e1c' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_directives_543e091b from 'nuxt_plugin_directives_543e091b' // Source: ../plugins/directives (mode: 'all')
import nuxt_plugin_components_2c318a2d from 'nuxt_plugin_components_2c318a2d' // Source: ../plugins/components (mode: 'all')
import nuxt_plugin_vuejsmodal_26c7eee7 from 'nuxt_plugin_vuejsmodal_26c7eee7' // Source: ../plugins/vue-js-modal (mode: 'all')
import nuxt_plugin_infiniteloading_589c174c from 'nuxt_plugin_infiniteloading_589c174c' // Source: ../plugins/infinite-loading (mode: 'client')
import nuxt_plugin_index_5593ff94 from 'nuxt_plugin_index_5593ff94' // Source: ../plugins/Notifications/index (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_index_212da206 from 'nuxt_plugin_index_212da206' // Source: ../plugins/svg-icons/index (mode: 'all')
import nuxt_plugin_swiper_3aa459e2 from 'nuxt_plugin_swiper_3aa459e2' // Source: ../plugins/swiper (mode: 'all')
import nuxt_plugin_message_177e2850 from 'nuxt_plugin_message_177e2850' // Source: ../plugins/message (mode: 'all')
import nuxt_plugin_index_fdb7a0b0 from 'nuxt_plugin_index_fdb7a0b0' // Source: ../plugins/Loading/index (mode: 'client')
import nuxt_plugin_video_f95a89f8 from 'nuxt_plugin_video_f95a89f8' // Source: ../plugins/video (mode: 'client')
import nuxt_plugin_client_7275c33c from 'nuxt_plugin_client_7275c33c' // Source: ../plugins/client (mode: 'client')
import nuxt_plugin_filters_a8b86778 from 'nuxt_plugin_filters_a8b86778' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_ckeditor_23a5bea8 from 'nuxt_plugin_ckeditor_23a5bea8' // Source: ../plugins/ckeditor (mode: 'client')
import nuxt_plugin_bmapNew_437dd462 from 'nuxt_plugin_bmapNew_437dd462' // Source: ../plugins/bmapNew (mode: 'client')
import nuxt_plugin_auth_437b2a99 from 'nuxt_plugin_auth_437b2a99' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_meta_481ee6ca from 'nuxt_plugin_meta_481ee6ca' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - 上船吧","htmlAttrs":{"lang":"zh"},"base":{"target":"_blank"},"meta":[{"charset":"utf-8"},{"name":"description","hid":"description","content":"【上船吧】（www.shangchuanba.com），致力于打造最大、最专业的邮轮平台，中国高端旅游资源整合运营商。从长江邮轮起步，未来基于国内外河轮、海洋邮轮、母港邮轮业务，打造邮轮旅游领域垂直网络分销平台。与各家B2B系统开通直连，为旅游企业、旅游从业者提供最便捷的销售、运营及管理工具。"},{"name":"format-detection","content":"telephone=no"},{"name":"renderer","content":"webkit"},{"name":"force-rendering","content":"webkit"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"name":"keywords","hid":"keywords","content":"上船吧,分销平台,资源整合平台,旅游,邮轮,邮轮旅游,邮轮,邮轮旅游,邮轮度假,邮轮度假,长江邮轮,海洋邮轮,境内邮轮,河轮,海轮,境外河轮,邮轮,极地邮轮,皇家加勒比,皇家,诺唯真,NCL,诺唯真邮轮,公主邮轮,MSC,地中海邮轮,中船嘉年华,维京邮轮,探索号,长江探索号,长江探索号邮轮,世纪游轮,松赞,松赞旅行,长江叁号,新东方快车"},{"name":"referrer","content":"strict-origin-when-cross-origin"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"defer":true,"src":"https:\u002F\u002Fhm.baidu.com\u002Fhm.js?94f7b3c26e20256f8c6c2024d459302d"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_d2bb196e === 'function') {
    await nuxt_plugin_plugin_d2bb196e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_8f4ea892 === 'function') {
    await nuxt_plugin_axios_8f4ea892(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_69306e1c === 'function') {
    await nuxt_plugin_elementui_69306e1c(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_543e091b === 'function') {
    await nuxt_plugin_directives_543e091b(app.context, inject)
  }

  if (typeof nuxt_plugin_components_2c318a2d === 'function') {
    await nuxt_plugin_components_2c318a2d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuejsmodal_26c7eee7 === 'function') {
    await nuxt_plugin_vuejsmodal_26c7eee7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_589c174c === 'function') {
    await nuxt_plugin_infiniteloading_589c174c(app.context, inject)
  }

  if (typeof nuxt_plugin_index_5593ff94 === 'function') {
    await nuxt_plugin_index_5593ff94(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fb9c9a02 === 'function') {
    await nuxt_plugin_axios_fb9c9a02(app.context, inject)
  }

  if (typeof nuxt_plugin_index_212da206 === 'function') {
    await nuxt_plugin_index_212da206(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_3aa459e2 === 'function') {
    await nuxt_plugin_swiper_3aa459e2(app.context, inject)
  }

  if (typeof nuxt_plugin_message_177e2850 === 'function') {
    await nuxt_plugin_message_177e2850(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_fdb7a0b0 === 'function') {
    await nuxt_plugin_index_fdb7a0b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_video_f95a89f8 === 'function') {
    await nuxt_plugin_video_f95a89f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_client_7275c33c === 'function') {
    await nuxt_plugin_client_7275c33c(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_a8b86778 === 'function') {
    await nuxt_plugin_filters_a8b86778(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ckeditor_23a5bea8 === 'function') {
    await nuxt_plugin_ckeditor_23a5bea8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bmapNew_437dd462 === 'function') {
    await nuxt_plugin_bmapNew_437dd462(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_437b2a99 === 'function') {
    await nuxt_plugin_auth_437b2a99(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_481ee6ca === 'function') {
    await nuxt_plugin_meta_481ee6ca(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
